import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
import { Col, Row } from "react-bootstrap";
const TicketportalError = (props) => {
    return (React.createElement(Row, { className: "d-flex align-item-center justify-content-center mx-0 text-center" },
        React.createElement(Col, { lg: 12 },
            props.iconSmall && React.createElement("span", { className: "edel-icon-Folder font-42" }),
            props.iconBig && React.createElement("span", { className: "edel-icon-Folder font-71" })),
        React.createElement(Col, { lg: 12, className: "mt-2" },
            React.createElement("span", { className: "DMSan_16_700 txt-midnight-blue" }, props.errorMsg)),
        React.createElement(Col, { lg: 12 },
            React.createElement("span", null,
                React.createElement("span", { className: "DMSan_14_500 pe-1" },
                    React.createElement("span", { className: "pe-1" }, "Click on"),
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "small-edbutton", value: "New Ticket", onClick: () => {
                            props.onClick();
                        } }),
                    React.createElement("span", { className: "" }, " to create one"))))));
};
export default TicketportalError;
